/* Stylesheet */

.controls {
  margin: 12px 12px 12px 0px;
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
}
